export default "__VITE_ASSET__db205a53__"